import React from "react"
import { Box, Button, Flex, Heading, Slide } from "@chakra-ui/react"
import Icon from "../Icon/Icon"
import { ClearAll, Filters, FiltersSelected, SortBy } from "@usereactify/search"
import FiltersSelectedComponent from "./FiltersSelectedComponent"
import { colors } from "@app/theme/colors"
import SortByDropdownMobile from "./SortByDropdownMobile"
import PerPageMobile from "./PerPageMobile"
import FilterListMobile from "./FilterListMobile"
import FilterSliderMobile from "./FilterSliderMobile"
import FilterRangeMobile from "@app/components/Filter/FilterRangeMobile"

const FilterDrawer: React.FC<any> = ({ isOpen, onClose, setPerPage, perPage }) => {
  return (
    <Slide direction="right" unmountOnExit={false} in={isOpen} style={{ zIndex: 9999999 }}>
      <Box
        style={{
          top: 0,
          left: 0,
          bottom: "100%",
          width: `100vw`,
          height: `100vh`,
          zIndex: 99999999,
          background: `white`,
          display: `flex`,
          flexDirection: `column`,
        }}
      >
        <Box as={`header`} top={0}>
          <Flex gap={1} flexDirection={"column"} px={2} py={2} borderBottom={"1px solid " + colors.brand.border}>
            <Flex w="100%" alignItems={"center"}>
              <Heading as="h3" size="lg">
                {`Filters & Sort `}
                <FiltersSelected
                  render={props => {
                    return (
                      <>
                        {`(`}
                        {props.selectedFilters.length}
                        {`)`}
                      </>
                    )
                  }}
                />
              </Heading>

              <Icon ml="auto" name="close" size="16px" onClick={() => onClose(false)}></Icon>
            </Flex>
            <FiltersSelected render={props => <FiltersSelectedComponent {...props} />}></FiltersSelected>
          </Flex>
        </Box>
        <Box flexGrow={1} overflow={"auto"} mb={16}>
          <Flex h="100%" position="relative" flexDirection={"column"}>
            <Flex flexDirection={"column"}>
              <SortBy
                render={props => {
                  return <SortByDropdownMobile {...props} />
                }}
              ></SortBy>
              <PerPageMobile setPerPage={setPerPage} perPage={perPage}></PerPageMobile>
              <Filters renderFilterList={FilterListMobile} renderFilterRange={FilterRangeMobile} renderFilterSlider={FilterSliderMobile} />
            </Flex>
          </Flex>
        </Box>
        <Box as={`footer`} position={`absolute`} bottom={0} left={0} zIndex={9} width={`full`}>
          <Flex p={2} bg="white" position="absolute" bottom={0} left={0} w="100%">
            <ClearAll
              render={props => {
                return (
                  <Button
                    size="sm"
                    mr={1}
                    variant="outline"
                    w="100%"
                    onClick={() => {
                      props.clearAll()
                    }}
                  >
                    CLEAR ALL
                  </Button>
                )
              }}
            ></ClearAll>
            <Button size="sm" variant="blue" w="100%" onClick={() => onClose(false)}>
              APPLY
            </Button>
          </Flex>
        </Box>
      </Box>
    </Slide>
  )
}

export default FilterDrawer
